export const TabList = [
	{
		id: "video",
		title: "Video",
	},
	{
		id: "audio",
		title: "Audio",
	},
	{
		id: "book",
		title: "Book",
	},
];


export const videoHeader = [
    { field: "createdAt", title: "DATE/TIME", width: 150 },
	{ field: "coverPhoto", title: "VIDEO THUMBNAIL", width: 150 },
	{ field: "name", title: "VIDEO TITLE", width: 150 },
	{ field: "totalDuration", title: "DURATION",  width: 100 },
	{ field: "category", title: "CATEGORY", sortable: false, width: 120 },
	{ field: "approve", title: "APPROVAL", width: 70 },
	{ field: "", title: "ACTION", sortable: false, width: 60 },
]

export const audioHeader = [
    { field: "createdAt", title: "DATE/TIME", width: 150 },
	{ field: "coverPhoto", title: "AUDIO THUMBNAIL", width: 150 },
	{ field: "name", title: "AUDIO TITLE", width: 150 },
	{ field: "totalDuration", title: "DURATION",  width: 100 },
	{ field: "category", title: "CATEGORY", sortable: false, width: 120 },
	{ field: "approve", title: "APPROVAL", width: 70 },
	{ field: "", title: "ACTION", sortable: false, width: 60 },
]

export const bookHeader = [
    { field: "createdAt", title: "DATE/TIME", width: 150 },
	{ field: "coverPhoto", title: "BOOK THUMBNAIL", width: 150 },
	{ field: "name", title: "BOOK TITLE", width: 150 },
	{ field: "category", title: "CATEGORY", sortable: false, width: 120 },
	{ field: "approve", title: "APPROVAL", width: 70 },
	{ field: "", title: "ACTION", sortable: false, width: 60 },
]

